import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_PROD_URL || process.env.REACT_APP_API_BASE_URL || "http://localhost:3002"; // Replace with actual backend URL   

export async function checkEligibility(practiceInfo, medicalAidInfo, patientInfo) {
  try {
    const response = await axios.post(`${API_URL}/soap/eligibilityCheck`, {
      practiceInfo,
      medicalAidInfo,
      patientInfo
    });
    console.log(response)
    if (response.status === 200) {
      return response.data; // Contains { matched, mismatched }
    } else {
      throw new Error("Unexpected response status: " + response.status);
    }
  } catch (error) {
    console.error("⛔ Error verifying dependants via Medikredit:", error);

    // ✅ Forward the error to the useEffect for 404/503 logic
    if (error.response && (error.response.status === 404 || error.response.status === 503)) {
      throw error;
    }

    // Optional fallback if it's not a known recoverable error
    throw new Error("Failed to verify dependants: " + (error.message || "Unknown error"));
  }
}

export async function checkFamilyEligibility(practiceInfo, medicalAidInfo) {
  try {
    const response = await axios.post(`${API_URL}/soap/familyCheck`, {
      practiceInfo,
      medicalAidInfo,
    });
    console.log(response)
    if (response.status === 200) {
      return response.data; // Contains { matched, mismatched }
    } else {
      throw new Error("Unexpected response status: " + response.status);
    }
  } catch (error) {
    console.error("⛔ Error verifying dependants via Medikredit:", error);

    // ✅ Forward the error to the useEffect for 404/503 logic
    if (error.response && (error.response.status === 404 || error.response.status === 503)) {
      throw error;
    }

    // Optional fallback if it's not a known recoverable error
    throw new Error("Failed to verify dependants: " + (error.message || "Unknown error"));
  }
}

// verify if dependants can be moved to a new account. This checks if they are present and correct on the new account
export async function verifyDependantsViaMedikredit(practiceInfo, mainMember, dependants) {
  try {
    const response = await axios.post(`${API_URL}/accounts/verifyDependantsViaMedikredit`, {
      practiceInfo,
      mainMember,
      dependants,
    });

    if (response.status === 200) {
      return response.data; // Contains { matched, mismatched }
    } else {
      throw new Error("Unexpected response status: " + response.status);
    }
  } catch (error) {
    console.error("⛔ Error verifying dependants via Medikredit:", error);

    // ✅ Forward the error to the useEffect for 404/503 logic
    if (error.response && (error.response.status === 404 || error.response.status === 503)) {
      throw error;
    }

    // Optional fallback if it's not a known recoverable error
    throw new Error("Failed to verify dependants: " + (error.message || "Unknown error"));
  }
}

// Submit Claim to Medikredit 
export async function submitMedikreditClaim(practiceInfo, medicalAidInfo, patientInfo, transactionInfo, financialInfo, caseInfo, IODInfo, patientMediKreditPlanNumber04) {
  try {
    const response = await axios.post(`${API_URL}/soap/claim`, {
      practiceInfo,
      medicalAidInfo,
      patientInfo,
      transactionInfo,
      financialInfo,
      caseInfo,
      IODInfo,
      patientMediKreditPlanNumber04,
    });

    if (response.status === 200) {
      return response.data; // Contains { transactionNumber, lineResults }
    } else {
      throw new Error("Unexpected response status: " + response.status);
    }
  } catch (error) {
    console.error("⛔ Error submitting claim via Medikredit:", error);

    if (error.response && (error.response.status === 404 || error.response.status === 503)) {
      throw error;
    }

    throw new Error(
  `Failed to submit claim: E02 - Please contact PractoSync support. ${
    error?.message || "Unknown error"
  }`
);
  }
}


